import React, { useState } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

const LeadActionModal = ({ lead, onSave, onClose, formData, setFormData }) => {
  // If formData and setFormData are provided from parent, use them
  // Otherwise, use local state (for backward compatibility)
  const [localAction, setLocalAction] = useState('');
  const [localNextAction, setLocalNextAction] = useState('');
  const [localFollowUpDate, setLocalFollowUpDate] = useState('');

  // Use parent formData if provided, otherwise use local state
  const action = formData?.action || localAction;
  const nextAction = formData?.nextAction || localNextAction;
  const followUpDate = formData?.followUpDate || localFollowUpDate;

  const setAction = setFormData ? (value) => setFormData(prev => ({ ...prev, action: value })) : setLocalAction;
  const setNextAction = setFormData ? (value) => setFormData(prev => ({ ...prev, nextAction: value })) : setLocalNextAction;
  const setFollowUpDate = setFormData ? (value) => setFormData(prev => ({ ...prev, followUpDate: value })) : setLocalFollowUpDate;

  const actionOptions = [
    'Connected',
    'No Answer',
    'Wrong Number',
    'Do Not Call',
    'Interested',
    'Not Interested',
    'Already Customer'
  ];

  const nextActionOptions = [
    'Follow Up',
    'Converted',
    'Close'
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!action || !nextAction) {
      alert('Please select both Action and Next Action');
      return;
    }

    if (nextAction === 'Follow Up' && !followUpDate) {
      alert('Please select a follow-up date');
      return;
    }

    onSave(action, nextAction, followUpDate);
  };

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-md bg-white">
        <div className="mt-3">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-medium text-gray-900">
              Lead Action - {lead?.name}
            </h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600"
            >
              <XMarkIcon className="h-6 w-6" />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="action" className="block text-sm font-medium text-gray-700 mb-1">
                Action *
              </label>
              <select
                id="action"
                value={action}
                onChange={(e) => setAction(e.target.value)}
                required
                className="input-field"
              >
                <option value="">Select Action</option>
                {actionOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label htmlFor="nextAction" className="block text-sm font-medium text-gray-700 mb-1">
                Next Action *
              </label>
              <select
                id="nextAction"
                value={nextAction}
                onChange={(e) => setNextAction(e.target.value)}
                required
                className="input-field"
              >
                <option value="">Select Next Action</option>
                {nextActionOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>

            {nextAction === 'Follow Up' && (
              <div>
                <label htmlFor="followUpDate" className="block text-sm font-medium text-gray-700 mb-1">
                  Follow-up Date *
                </label>
                <input
                  type="datetime-local"
                  id="followUpDate"
                  value={followUpDate}
                  onChange={(e) => setFollowUpDate(e.target.value)}
                  required
                  className="input-field"
                />
              </div>
            )}

            <div className="flex justify-end space-x-3 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="btn-secondary"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn-primary"
              >
                Save Action
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LeadActionModal;


